<template>
  <!-- 优惠券页面，无法修改，只能查看。但是可以选择，如果入口是【我的】，则只能查看，无法选择
  如果是订单支付页面，则可以选择-根据参数决定。选择时，支持设置最多选择的个数，默认只有一张，这样
  可以灵活制定策略
  设置消费门槛值，决定哪些可以高亮，哪些不行
   -->
  <div class="user-conpons-box">
    <van-popup v-model="showing"  position="bottom">
      <!-- 优惠券列表 -->
      <van-coupon-list
        :show-exchange-bar="false"
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<script>
import {CouponList, CouponCell, Popup} from 'vant';
import Vue from 'vue';
import moment from 'moment';

Vue.use(CouponList).use(CouponCell).use(Popup);

export default {
  name: 'coupon-select',
  props: {
    onCouponSelected: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    value: Boolean
  },
  model: {
    event: 'show'
  },
  watch: {
    // showPopup(newShow) {
    //   this.$emit('change', newShow);
    // }
    value(newVal) {
      this.showing = newVal;
    },
    showing(newShow) {
      this.$emit('show', newShow);
    }
  },
  data() {
    return {
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: [],

      showing: this.value
    }
  },
  mounted() {
    this.reloadAll();
  },
  methods: {
    onChange(index) {
      this.chosenCoupon = index;
      if (this.onCouponSelected) {
        const coupon = this.coupons[index];
        this.onCouponSelected(index, coupon);
      }

// 插件选择: 不使用优惠券 按钮时，会出现-1
      // if (index === -1) {
      //   }
      this.showing = false;
    },
    // 转化格式为 组件的数据
    asVantCoupon(coupon, available = true) {
      if (!_.isEmpty(coupon)) {
        const vc = {};
        vc.available = available ? 1 : 0;
        vc.condition = coupon.description;
        vc.value = coupon.discount;
        vc.name = coupon.summary;
        vc.valueDesc = coupon.discount_yuan;
        vc.unitDesc = '元';
        if (!_.isEmpty(coupon.start_valid)) {
          vc.startAt = moment(coupon.start_valid).unix();
        }
        if (!_.isEmpty(coupon.end_valid)) {
          vc.endAt = moment(coupon.end_valid).unix();
        } else {
          vc.endAt = moment().add(50, 'year').unix();
        }
        if (!available) {
          switch(coupon.status) {
            case 'consume':
              vc.reason = '已使用';
              break;
            case 'offer':
              vc.reason = '已赠送';
              break;
            case 'expired':
              vc.reason = '已过期';
              break;
          }
        }
        vc.origin = coupon;
        return vc;
      }
    },
    reloadAll(amount) {
      this.$http.get('/api/coupon/list', {params: {amount: amount}}).then(res => {
        if (res) {
          this.coupons = res.data.data.available.map(f => this.asVantCoupon(f));
          this.disabledCoupons = res.data.data.disabled.map(f => this.asVantCoupon(f, false));
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sby-coupon-select.vue